<template>
  <div>
    <div class="row ma-0 mb-4">
      <h1 :style="{ color: $themes.primary, textTransform: 'uppercase' }">{{ title }}</h1>
    </div>

    <va-card class="flex md6 xs12">
      <form @submit.prevent="handleCategory">
        <div class="row ma-0">
          <file-upload v-model="category.photo" :error="!!errorsPhoto.length" :errorMessage="errorsPhoto" />
        </div>

        <div class="row ma-0">
          <div class="flex md6 xs12">
            <va-input
              label="Nome *"
              v-model="category.name"
              :error="!!nameErrors.length"
              :error-messages="nameErrors" />
          </div>

          <!-- <div class="flex md6 xs12">
            <va-input-wrapper :error="!!serviceErrors.length" :error-messages="serviceErrors">
              <va-select
                label="Serviços *"
                v-model="category.services"
                textBy="description"
                multiple
                :required="true"
                :options="services"
                :error="!!serviceErrors.length" />
            </va-input-wrapper>
          </div> -->
        </div>

        <div class="row ma-0">
          <va-button outline color="danger" @click="$router.push({ name: 'categories' })">Voltar</va-button>
          <va-button type="submit">{{ buttonText }}</va-button>
        </div>
      </form>
    </va-card>
  </div>
</template>

<script>
import FileUpload from '../components/FileUpload.vue'
import api from '../api'

export default {
  data () {
    return {
      nameErrors: [],
      errorsPhoto: [],
      category: {
        photo: '',
      },
    }
  },
  components: {
    FileUpload,
  },
  computed: {
    title () {
      return this.$route.params.id
        ? 'Editar Categoria'
        : 'Nova Categoria'
    },

    buttonText () {
      return this.$route.params.id
        ? 'Editar'
        : 'Cadastrar'
    },
  },
  mounted () {
    if (this.$route.params.id) {
      api.get(`/category/${this.$route.params.id}`)
        .then(res => {
          this.category = res.data
        })
        .catch(err => console.log(err.message))
    }
  },
  methods: {
    handleCategory () {
      this.nameErrors = this.category.name ? [] : ['Nome é obrigatório']
      this.errorsPhoto = this.category.photo ? [] : ['Escolha uma imagem']
      // this.serviceErrors = this.category.services.length ? [] : ['Escolha pelo menos um serviço']

      if (this.nameErrors.length || this.errorsPhoto.length) return

      // CREATE CATEGORY
      if (!this.$route.params.id) {
        api.post('/category', this.category)
          .then(res => {
            this.showToast('Categoria adicionada')

            this.$router.push({ name: 'categories' })
          })
          .catch(err => console.log(err.message))
      } else {
        // EDIT CATEGORY
        api.put(`/category/${this.$route.params.id}`, this.category)
          .then(res => {
            this.showToast('Categoria atualizada')

            this.$router.push({ name: 'categories' })
          })
          .catch(err => console.log(err.message))
      }
    },
  },
}
</script>
